'use strict';

var ACC;
ACC.emailsignup = {

  validEmail: false,

  _autoload: ['bindEmailSignup'],
  $emailSignUpForm: $('#emailSignUpForm'),
  $emailGenderInput: $('#signUpGender'),
  $womenEmailSignUpBtn: $('#womenEmailSignUp'),
  $menEmailSignUpBtn: $('#menEmailSignUp'),
  $signUpEmailId: $('#signUpEmailId'),

  bindEmailSignup: function() {
    ACC.emailsignup.$emailSignUpForm.on('submit', function(e) {
      // if the user has not selected a gender, prevent form submission
      if (ACC.emailsignup.$emailGenderInput.val() === '') {
        e.preventDefault(); 
      }
    })    

    ACC.emailsignup.$womenEmailSignUpBtn.on('click', function() {
      var signUpEmail = ACC.emailsignup.$signUpEmailId.val();
      ACC.emailsignup.validateEmailAddress(signUpEmail);

      if (ACC.emailsignup.validEmail === true) {
        ACC.emailsignup.submitEmailSignUpForm('FEMALE');
      }
    });

    ACC.emailsignup.$menEmailSignUpBtn.on('click', function() {
      var signUpEmail = ACC.emailsignup.$signUpEmailId.val();
      ACC.emailsignup.validateEmailAddress(signUpEmail);

      if (ACC.emailsignup.validEmail === true) {
        ACC.emailsignup.submitEmailSignUpForm('MALE');
      } 
    });

    ACC.emailsignup.$signUpEmailId.focus(function() {
      ACC.emailsignup.$signUpEmailId.val('');
    });
  },

  submitEmailSignUpForm: function(gender) {
    ACC.emailsignup.$emailGenderInput.val(gender);
    $('#lastVisitedPageUrl').val(window.location.href);
    ACC.emailsignup.$emailSignUpForm.submit();
  },

  validateEmailAddress: function(emailId) {
    if (emailId != undefined && emailId.length > 0) {
      var emailProperty = $('#emailRegex').text();
      var regex = new RegExp(emailProperty);

      if (regex.test(emailId)) {
        ACC.emailsignup.validEmail = true;
      } else {
        ACC.emailsignup.$signUpEmailId.val(ACC.emailsignup.$signUpEmailId.data('validemail')).addClass('invalid-email-error');
        ACC.emailsignup.$signUpEmailId.on('click focusin', function() {
          ACC.emailsignup.$signUpEmailId.removeClass('invalid-email-error');
        });
      }
    } else {
      ACC.emailsignup.$signUpEmailId.val(ACC.emailsignup.$signUpEmailId.data('error')).addClass('invalid-email-error');
      ACC.emailsignup.$signUpEmailId.on('click focusin', function() {
        ACC.emailsignup.$signUpEmailId.removeClass('invalid-email-error');
      });
    }
  }

};